<template>
  <div>
    <h3>Incoming Calls</h3>
    
    <div v-if="twilioSyncStore.isTwilioFrameworkAvailable">
      <div v-if="showOptions">
      <div @click="showOptions = false">⚙️⌃</div>
      Show Extra Data: <input type="checkbox" v-model="showExtraData" /> 
      </div>
      <div v-else>
        <div @click="showOptions = true">⚙️⌄</div>
      </div>
      
      <table>
        <tr>
          
          <th>Date Updated</th>
          <!-- <th>Time on Call</th>
          <th>Time on Call</th> -->
          <th>Key</th>
          <th>From</th>
          <th>To</th>
          <th>Called</th>
          <!-- <th>Call Status</th> -->
          <th v-if="showExtraData">Data</th>
          <th v-if="showExtraData">Keys</th>
        </tr>
        <tr v-for="call in sortedCalls" :key="call.key">
          <td>{{d(call["date_updated"])}}</td>
          <!-- <td>{{diff(call["date_updated"])}}</td>
          <td>{{diffHumanize(call["date_updated"])}}</td> -->
          <td><a :href="`https://www.twilio.com/console/voice/calls/logs/${call.key}`" target="_blank">{{call["key"]}}</a> ↗︎</td>
          <td>{{$util.formatPhoneNumber(call["data"]["From"])}}</td>
          <td>{{$util.formatPhoneNumber(call["data"]["To"])}}</td>
          <td>{{$util.formatPhoneNumber(call["data"]["Called"])}}</td>
          <!-- <td>{{call["data"]["CallStatus"]}}</td> -->

          <td v-if="showExtraData">{{call["data"]}}</td>
          <td v-if="showExtraData">{{Object.keys(call)}}</td>
          
        </tr>
      </table>

      <h3>Old Calls</h3>
      <table>
        <tr>
          
          <th>Date Updated</th>
          <th>Key</th>
          <th>From</th>
          <th>To</th>
          <th>Called</th>
          <th>Call Status</th>
          <th v-if="showExtraData">Data</th>
          <th v-if="showExtraData">Keys</th>
        </tr>
        <tr v-for="call in oldCalls.slice(0,10)" :key="call.key">
          <td>{{d(call["date_updated"])}}</td>
          <td><a :href="`https://www.twilio.com/console/voice/calls/logs/${call.key}`" target="_blank">{{call["key"]}}</a> ↗︎</td>
          <td>{{$util.formatPhoneNumber(call["data"]["From"])}}</td>
          <td>{{$util.formatPhoneNumber(call["data"]["To"])}}</td>
          <td>{{$util.formatPhoneNumber(call["data"]["Called"])}}</td>
          <!-- <td>{{call["data"]["CallStatus"]}}</td> -->

          <td v-if="showExtraData">{{call["data"]}}</td>
          <td v-if="showExtraData">{{Object.keys(call)}}</td>
          
        </tr>
        <tr v-if="oldCalls.length > 9"><td>...</td></tr>
      </table>
    </div>

    
    <div v-else>
      <h3>Error: Twillio Framework Not Available</h3>
    </div>
    
  </div>  
</template>

<script>
export default {
  name:"PhoneDebugTable",
  data () { return {
    calls:[],
    oldCalls:[],
    showExtraData: false,
    showOptions: false,
  }},
  inject: ['phonePage'],
  watch: {
    syncClient: function(){
      if (this.syncClient === undefined)
        return;
      this.syncClient.map('incoming_customer_calls')
      .then(map => {

        map.getItems().then((_map)=>{
          _map.items.forEach(item=>{
            console.log(item.descriptor.key, item.descriptor);
            this.calls.push(item.descriptor);
          })
        })
        // Listen to updates on the Map
        map.on('updated', function(event) {
          console.log('Received Map update event. New value:', event.value);
        });
        map.on('itemUpdated', function(args) {
          console.log('Map item ' + args.item.key + ' was updated');
          console.log('args.item.value:', args.item.value);
          console.log('args.isLocal:', args.isLocal);
        });
        map.on('itemAdded', args => {
          console.log('Map item ' + args.item.key + ' was added');
          this.calls.push(args.item.descriptor)
        });
        map.on('itemRemoved', args => {
          console.log('Map item ' + args.key + ' was removed');
          this.oldCalls.unshift(this.calls.filter(call=>call.key === args.key)[0]);
          this.calls = this.calls.filter(call=>call.key !== args.key);
        });
      });
      
    }
  },
  mounted: function(){
    
  },
  methods:{
    d: val => moment(val).format('h:mm:ss a'),
    diff: function(val){
      let now = moment(new Date).utc()
      let then = moment.utc(val);
      return moment.duration(now.diff(then)).asSeconds();
    },
    diffHumanize: function(val){
      let now = moment(new Date).utc()
      let then = moment.utc(val);
      return moment.duration(now.diff(then)).humanize()
    },
  
  },
  computed: {
    sortedCalls: function(){
      return this.$util.sortAscForKeyPath(this.calls, `date_updated`)
    },
    twilioSyncStore(){
      return this.phonePage.$refs.twilioSyncStore;
    },
    syncClient(){
      return this.twilioSyncStore.syncClient;
    },
  }
}
</script>

<style scoped>

</style>